import React from "react";
import Page from "@jumbo/shared/Page";
import Login from "app/pages/login";
import MyRouteMiddleware from "./middleware/auth/authValidRoute";


import { approvalConfigMasterRoute } from "./approvalConfigRoutes";
import { challanModuleRoute } from "./challanModuleRoute";
import { coreInventoryRoute } from "./coreInventoryRoutes";
import { dispatchModuleRoute } from "./dispatchModuleRoute";
import { faceInventoryRoute } from "./faceInventoryRoutes";
import { factoryRoutes } from "./factoryRoutes";
import { fleeceInventoryRoute } from "./fleeceInventoryRoutes";
import { flitchInventoryRoute } from "./flitchInventoryRoutes";
import { logInventoryRoute } from "./logInventoryRoutes";
import { masterRoutes } from "./masterRoutes";
import { mdfInventoryRoute } from "./mdfInventoryRoutes";
import { orderModuleRoute } from "./orderModuleRoute";
import { otherGoodsRoutes } from "./otherGoodsRoutes";
import { packingModuleRoute } from "./packingModuleRoute";
import { plywoodInventoryRoute } from "./plywoodInventoryRoutes";
import { seriesProductRoutes } from "./seriesProductRoutes";
import userManagementRoutes from "./userManagementRoutes";
import { veneerInventoryRoute } from "./veneerInventoryRoutes";

const Dashboard = React.lazy(() => import("app/pages/Dashboard"));
const ForgotPassword = React.lazy(() => import("app/pages/ForgotPassword"));
const PasswordOtp = React.lazy(() => import("app/pages/Otp"));
const EditUserProfile = React.lazy(() => import("app/pages/UserManagement/Edit Profile"));
/**
 routes which you want to make accessible to both authenticated and anonymous users
 **/
// const {isAuthenticated}
const routesForPublic = [
  {
    path: "/",
    element: <Page component={Login} layout={"solo-page"} />,
  },
  {
    path: "/user/login",
    element: <Page component={Login} layout={"solo-page"} />,
  },
  {
    path: "/password/reset",
    element: <Page component={ForgotPassword} layout={"solo-page"} />,
  },
  {
    path: "/password/otp",
    element: <Page component={PasswordOtp} layout={"solo-page"} />,
  },
  {
    middleware: [
      {
        element: MyRouteMiddleware,
        fallbackPath: "/user/login",
      },
    ],
    routes: [
      {
        path: "/profile",
        element: (
          <Page component={EditUserProfile} layout={"vertical-default"} />
        ),
      },
      {
        path: "/dashboard",
        element: <Page component={Dashboard} layout={"vertical-default"} />,
      },
      ...userManagementRoutes,
      ...masterRoutes,
      ...approvalConfigMasterRoute,
      ...otherGoodsRoutes,
      ...factoryRoutes,
      ...logInventoryRoute,
      ...veneerInventoryRoute,
      ...flitchInventoryRoute,
      ...plywoodInventoryRoute,
      ...faceInventoryRoute,
      ...fleeceInventoryRoute,
      ...coreInventoryRoute,
      ...mdfInventoryRoute,
      ...seriesProductRoutes,
      ...orderModuleRoute,
      ...packingModuleRoute,
      ...dispatchModuleRoute,
      ...challanModuleRoute,
      ...packingModuleRoute
    ],
  },
];
// {
//   path: "/",
//   element: <Page component={Home} layout={"vertical-default"} />,
// },
// {
//   middleware: [
//     {
//       element: MyRouteMiddleware,
//       fallbackPath: "/user/login",
//     },
//   ],
//   routes: [...dashboardRoutes],
// },
/**
 routes only accessible to authenticated users
 **/
const routesForAuthenticatedOnly = [];

/**
 routes only accessible when user is anonymous
 **/
const routesForNotAuthenticatedOnly = [
  // {
  //   path: "/user/login",
  //   element: (
  //     <Page component={Login} layout={"solo-page"} disableSmLogin={true} />
  //   ),
  // },
];

const routes = [
  ...routesForPublic,
  ...routesForAuthenticatedOnly,
  ...routesForNotAuthenticatedOnly,
];

export {
  routes as default,
  routesForAuthenticatedOnly,
  routesForNotAuthenticatedOnly,
  routesForPublic
};

